import { useMemo } from 'react';
import { createTheme, lightThemeStyles, darkThemeStyles, clientThemesStyles, getCssText, styled } from '../theme/stitches.config';

// Types
import { Themes } from '../types';

const deepMerge = (a: any, b: any, fn: any) =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore

  [...new Set([...Object.keys(a), ...Object.keys(b)])].reduce((acc, key) => ({ ...acc, [key]: fn(key, a[key], b[key]) }), {});

export default function useTheme(name: Themes, themes?: { [key in Themes]?: unknown }) {
  const { themeName, themeStyles } = useMemo(() => {
    const acceptedThemes = ['light', 'dark', 'client'];
    const themeName = acceptedThemes.includes(name) ? name : 'light';

    // TODO create a corresponding theme type
    let styles: any = lightThemeStyles;

    if (acceptedThemes.includes(name)) {
      styles = deepMerge(
        name === 'dark' ? darkThemeStyles : name === 'client' ? clientThemesStyles : lightThemeStyles,
        themes?.[name],
        (key: string, a: any, b: any) => (key === 'a' ? a && b : Object.assign({}, a, b)),
      );
    }
    const themeStyles = createTheme(themeName, styles);

    return { themeName, themeStyles };
  }, [name, themes]);

  return { themeName, themeStyles, getCssText, styled };
}
